import { Component, Input } from '@angular/core';
import {
    ProfileCandidateScoreRating,
    UserCandidateScoreRating
} from 'src/app/martech/models/candidate-score-rating.model';
import { CandidateScoreRating } from '../../enums/candidate-score-rating.enum';

@Component({
    selector: 'nova-candidate-score-display',
    templateUrl: './candidate-score-display.component.html',
    styleUrls: ['./candidate-score-display.component.scss']
})
export class CandidateScoreDisplayComponent {
    @Input() set profiles(p: UserCandidateScoreRating) {
        if (!p) {
            this.profileList = [];
            return;
        }
        this.profileList = Object.values(p.profiles).sort((a, b) => a.ratingId - b.ratingId);
    }

    CandidateScoreRating = CandidateScoreRating;

    profileList: ProfileCandidateScoreRating[];

    constructor() {}
}
